import { useTranslation } from 'react-i18next';
import {
	GovAttachments,
	GovAttachmentsItem,
} from '@gov-design-system-ce/react';
import type { MessagesProps } from '@gov-design-system-ce/react-form';
import { FormMessage } from '@gov-design-system-ce/react-form';
import type { FileUploadItem } from '@gov-nx/core/hooks';
import { FileState } from '@gov-nx/core/hooks';
import {
	LocalizeNameSpaceTypes,
	useTranslationWithNamespace,
} from '@gov-nx/core/service';
import { formatBytes } from '@gov-nx/utils/common';

const color = (fileState: FileState) => {
	if (fileState === FileState.success || fileState === FileState.error) {
		return fileState;
	}
	return 'neutral';
};

export interface FormUploadAttachmentsProps {
	files: FileUploadItem[];
	onRemove: (fileId: string) => void;
}

export const FormUploadAttachments = ({
	files,
	onRemove,
}: FormUploadAttachmentsProps) => {
	const { getLocalizeCurried } = useTranslationWithNamespace();
	const { t } = useTranslation(LocalizeNameSpaceTypes.Form);
	const ts = getLocalizeCurried(LocalizeNameSpaceTypes.Form);

	const messages = (file: FileUploadItem): MessagesProps['messages'] => {
		if (file.message) {
			return {
				color: color(file.state),
				children: t(file.message),
			};
		}
		return [];
	};

	if (files.length === 0) {
		return null;
	}

	return (
		<div>
			<h2 className="mt-4! text-headline-s!">
				{ts('nahrani-souboru.prilohy')}
			</h2>
			<GovAttachments>
				{files
					.sort((a, b) => a.index - b.index)
					.map((file) => (
						<GovAttachmentsItem
							key={file.id}
							accessibleRemoveLabel={t(
								'nahrani-souboru.wcag.odstranit-soubor',
								{
									namespace: LocalizeNameSpaceTypes.Form,
									fileName: file.name,
								}
							)}
							onRemove={() => onRemove(file.id)}
							info={<span>({formatBytes(file.size)})</span>}
							message={
								<div>
									<FormMessage messages={messages(file)} />
								</div>
							}>
							{file.name}
						</GovAttachmentsItem>
					))}
			</GovAttachments>
		</div>
	);
};
